import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    TextField,
    SelectInput,
    DateInput,
    DateField,
    ReferenceField,
    required,
    ReferenceManyField, Datagrid, EditButton,
    Pagination
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { emailFinderStatuses } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const EmailFinderEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <TextInput name="name" source="name" validate={[required()]} />
                        <TextInput name="targetUrl" source="targetUrl" validate={[required()]} />

                        <SelectInput source="status" choices={ emailFinderStatuses } validate={[required()]} />
                        <Box sx={ {
                            display: 'flex',
                            flexDirection: 'Column'
                        } }>
                            <span>{ "Results" }</span>
                            <ReferenceManyField source="emailFinderResults"
                                                perPage={ 10 }
                                                pagination={ <Pagination /> }
                                                reference="email_finder_results" target="id" label="MysteryShoppers">
                                <Datagrid bulkActionButtons={ false }>
                                    <TextField source="id" />
                                    <TextField source="name" />
                                    <TextField source="department" />
                                    <EditButton label="View" />
                                </Datagrid>
                            </ReferenceManyField>
                        </Box>
                    </Grid>
                    <Grid size={ 6 }>
                        <TextInput name="totalFound" source="totalFound" />
                        <TextInput name="totalNew" source="totalNew" />
                        <DateInput source="startTime" validate={[required()]} />
                        <DateInput source="endTime" validate={[required()]} />
                        <DateInput source="scheduleDate" />
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } } >
                            <span>{ "Created" }</span>
                            <DateField source="createdAt" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "Customer Account" }</span>
                            <ReferenceField source="customerAccount"  reference="customer_accounts" />
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
